import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-question-opener',
			dom: {
				toggler: '.js-question-opener-toggler',
				content: '.js-question-opener-content',
				text: '.js-question-opener-text',
				vote: '.js-question-opener-vote'
			},
			classes: {
				opener: {
					state: {
						open: 'b-question-opener_state_open'
					}
				}
			},
			parent: false,
			base: false
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$body = $(document.body);
		this.$html = $('html');
		this.$htmlBody = this.$body.add(this.$html);
		return this;
	}

	getDom() {
		this.$toggler = this.$el.find(this.options.dom.toggler);
		this.$content = this.$el.find(this.options.dom.content);
		this.$text = this.$el.find(this.options.dom.text);
		this.$vote = this.$el.find(this.options.dom.vote);
		return this;
	}

	toggler(e) {
		const $target = !isNaN(e) ? this.$el.eq(e) : $(e.target);

		if ($target.length) {
			const $thisOpener = $target.closest(this.options.el);
			const $thisContent = $thisOpener.find(this.options.dom.content);
			const $thisText = $thisOpener.find(this.options.dom.text);
			const $thisVote = $thisOpener.find(this.options.dom.vote);

			const heightAll = $thisText.outerHeight(true) + $thisVote.outerHeight(true);
			if ($thisOpener.hasClass(this.options.classes.opener.state.open)) {
				$thisContent.height(0);
				$thisOpener.removeClass(this.options.classes.opener.state.open);
				if (this.options.parent.init) {
					this.options.parent.setHash([this.options.base, this.getAncor()]);
				}
			} else {
				$thisContent.height(heightAll);
				$thisOpener.addClass(this.options.classes.opener.state.open);

				if (this.options.parent.init) {
					this.options.parent.setHash([this.options.base, $thisOpener.data('ancor')]);
				}
			}
		}
	}

	getAncor() {
		const $active = this.$el.filter('.' + this.options.classes.opener.state.open).first();
		return $active.length ? $active.data('ancor') : '';
	}

	setAncor(ancor, isInit = false) {
		const self = this;
		const $target = self.$el.filter('[data-ancor="' + ancor + '"]');
		const $active = self.$el.filter('.' + self.options.classes.opener.state.open);
		$active.each(function () {
			self.toggler($(this).index());
		});

		if ($target.length) {
			self.toggler($target.index());
			if (isInit) {
				self.$htmlBody.animate({scrollTop: $target.offset().top - 106}, 500);
			}
		}
		return self;
	}

	render() {
		this.getDom();
		this.$toggler.on('click', this.toggler.bind(this));
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/helper/question-opener/question-opener.js